export const skillSpecialCollection: Record<string, ({ data }: { data: any }) => string> = {
  crushBone: ({ data }) => {
    const { value, multiplier } = data
    if (value) {
      return `施放时，忽略敌方 <span class="grow">${value}</span>防御。`
    } else {
      return `施放时，忽略敌方 <span class="grow">${multiplier}%</span>的防御。`
    }
  },
}
